import { useEffect, useState } from 'react'
import { SELLER_DECATHLON } from 'src/constants'
import { clientStore } from 'src/services/axiosInstance'

const BASE_CASHBACK_URL = '/app/pub/cashback/orderFormId'

type CashbackTotalizer = {
  value: number
  valueFormatted: string
}

type CashbackResponse = {
  totalizers: CashbackTotalizer[]
}

type CartFeedbackItem = {
  seller: string
}

type UseCartFeedbackCashbackParams = {
  orderFormId?: string
  cartItems: CartFeedbackItem[]
}

type UseCartFeedbackCashbackResult = {
  cashbackValue: string
  hasCashback: boolean
}

export function useCartFeedbackCashback(
  params: UseCartFeedbackCashbackParams
): UseCartFeedbackCashbackResult {
  const { orderFormId, cartItems } = params
  const [cashbackValue, setCashbackValue] = useState('')

  useEffect(() => {
    let isActive = true

    const updateCashbackValue = async () => {
      const isEligible = cartItems?.some(
        ({ seller }) => seller === SELLER_DECATHLON
      )

      if (!isEligible || !orderFormId) {
        if (isActive) {
          setCashbackValue('')
        }

        return
      }

      try {
        const { data: cashbackData } = await clientStore.get<CashbackResponse>(
          `${BASE_CASHBACK_URL}/${orderFormId}`
        )

        const cashbackTotalizer = cashbackData?.totalizers?.[0]

        if (!isActive) {
          return
        }

        if (!cashbackTotalizer || cashbackTotalizer.value < 1) {
          setCashbackValue('')

          return
        }

        setCashbackValue(cashbackTotalizer.valueFormatted)
      } catch {
        if (isActive) {
          setCashbackValue('')
        }
      }
    }

    updateCashbackValue()

    return () => {
      isActive = false
    }
  }, [cartItems, orderFormId])

  return {
    cashbackValue,
    hasCashback: Boolean(cashbackValue),
  }
}
